import { api } from "@/lib/api";

import type {
  ItemCostHistoryEntry,
  ItemHistoryList,
  ProductPriceHistoryEntry,
} from "@artisancode/api-types";

export const itemHistoryService = {
  productPrice: (productId: string) =>
    api.get<ItemHistoryList<ProductPriceHistoryEntry>>(
      `/products/${productId}/price-history`,
    ),

  productCost: (productId: string) =>
    api.get<ItemHistoryList<ItemCostHistoryEntry>>(
      `/products/${productId}/cost-history`,
    ),

  rawMaterialCost: (rawMaterialId: string) =>
    api.get<ItemHistoryList<ItemCostHistoryEntry>>(
      `/raw-materials/${rawMaterialId}/cost-history`,
    ),
};
